import { CSSProperties, ReactNode } from 'react';

interface ScrollableListProps<T> {
  items: T[];
  renderItem?: (item: T, index: number) => ReactNode;
  maxHeight?: number | string;
  hideScrollbar?: boolean;
  className?: string;
  style?: CSSProperties;
  edit?: boolean;
  deleteItem?: boolean;
  editOnClick?: (item: T) => void;
  deleteOnClick?: (item: T) => void;
}

export function ScrollableList<T>({
  items,
  renderItem,
  maxHeight = 450,
  hideScrollbar = true,
  className = '',
  style,
  edit,
  editOnClick,
  deleteItem,
  deleteOnClick,
}: ScrollableListProps<T>) {
  const maxH = typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;

  return (
    <div
      className={`scrollable-list ${hideScrollbar ? 'hide-scrollbar' : ''} ${className}`}
      style={{ maxHeight: maxH, ...style }}
    >
      <ul>
        {items?.map((item, i) => (
          <li key={i}>
            {renderItem ? renderItem(item, i) : String(item)}
            <div className="flex-row gap-1">
              {edit && (
                <button onClick={editOnClick ? () => editOnClick(item) : undefined}>edit</button>
              )}
              {deleteItem && (
                <button onClick={deleteOnClick ? () => deleteOnClick(item) : undefined}>
                  delete
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
      <span className="sr-only" aria-live="polite">
        {items?.length ?? 0} items
      </span>
    </div>
  );
}
